module.exports = __webpack_public_path__ + "static/media/OGL_Logo.43402ea2.svg";